/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desk_Sso_Error_ForbiddenInputs */

const vi_desk_sso_error_forbidden = /** @type {(inputs: Desk_Sso_Error_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản của bạn không có quyền mở trang hỗ trợ. Vui lòng liên hệ quản trị viên nếu cần được cấp quyền.`)
};

/**

* @param {Desk_Sso_Error_ForbiddenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const desk_sso_error_forbidden = /** @type {((inputs?: Desk_Sso_Error_ForbiddenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desk_Sso_Error_ForbiddenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_desk_sso_error_forbidden(inputs)
});